import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IBrandParams, IBrandResponse, IBrandState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchUpdateBrand = createAsyncThunk(
  'listBrands/fetchUpdateBrand',
  async ({ id, params }: { id: string; params: IBrandParams }, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.updateBrand(id, params)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IBrandState = {
  isLoading: false,
  response: null,
  error: null
}

const updateBrandSlice = createSlice({
  name: 'states/show',
  initialState,
  reducers: {
    resetUpdateBrand: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchUpdateBrand.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchUpdateBrand.fulfilled, (state, action: PayloadAction<IBrandResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchUpdateBrand.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default updateBrandSlice.reducer
export const { resetUpdateBrand } = updateBrandSlice.actions
